/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import useSkillBasedQueueService from 'domain/gpo/skillBasedQueue/shared/skillBasedQueueService';

const SkillBasedQueueContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getPplPermissions } = useSkillBasedQueueService();
  const CONTEXT_NAME = 'SKILL_BASED_QUEUE_CONTEXT';

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPplPermissions}
      permissionToCheck={permissionToCheck}
      contextName={CONTEXT_NAME}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default SkillBasedQueueContext;
